<template>    
    <div class="datepicker">
        <vue-datepicker :name="id" v-model="date" :class="attributes.classes != undefined ? attributes.classes.value : ''" :config="options" :disabled="disabled || (alwaysLocked != null && alwaysLocked)" @dp-change="onChange"></vue-datepicker>    
    </div>
</template>

<script>
    import vueDatepicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    export default {
        props: ['id', 'attributes', 'value', 'reset', 'locked'],

        components: {vueDatepicker},

        data() {
            return {
                //https://github.com/ankurk91/vue-bootstrap-datetimepicker
                date: null,
                options: {
                    format: "DD/MM/YYYY LT",
                    useCurrent: true,
                    showClear: true,
                    showClose: true,
                    locale: 'it',
                    tooltips: {
                        today: 'Vai ad oggi',
                        clear: 'Resetta selezione',
                        close: 'Chiudi',
                        selectMonth: 'Seleziona mese',
                        prevMonth: 'Mese precedente',
                        nextMonth: 'Mese successino',
                        selectYear: 'Seleziona anno',
                        prevYear: 'Anno precedente',
                        nextYear: 'Anno successivo',
                        selectDecade: 'Seleziona decade',
                        prevDecade: 'Decade precedente',
                        nextDecade: 'Decade successiva',
                        prevCentury: 'Secolo precedente',
                        nextCentury: 'Secolo successivo'
                    },
                    widgetPositioning: {
                        horizontal: 'auto',
                        vertical: 'bottom',
                    },
                    icons: {
                        time: 'fas fa-clock',
                        date: 'fas fa-calendar',
                        up: 'fas fa-chevron-up',
                        down: 'fas fa-chevron-down',
                        previous: 'fas fa-chevron-left',
                        next: 'fas fa-chevron-right',
                        today: 'fas fa-crosshairs',
                        clear: 'fas fa-trash-o',
                        close: 'fas fa-times'
                    },
                },                
                disabled: false,
                alwaysLocked: null
            }
        },

        created() {
            if(this.value != undefined)
                this.date = this.value;
            else if(this.attributes.value != undefined)
                this.date = this.attributes.value.value;

            if(this.attributes != undefined) {

                if(this.attributes.dateFormat != undefined)
                    this.options['format'] = this.attributes.dateFormat.value;
                if(this.attributes.required != undefined)
                    this.options['showClear'] = this.attributes.required.value;
            }

            if(this.attributes.alwaysLocked != undefined) {
                this.alwaysLocked = this.attributes.alwaysLocked.value;
            }

            if(this.locked != undefined && this.locked)
                this.disabled = this.locked;
            else if(this.attributes.disabled != undefined && this.attributes.disabled.value)
                this.disabled = this.attributes.disabled.value;
            
            if(this.date)
                this.broadcast();
        },

        watch:{
            reset() {
                this.$set(this, 'date', null);
                this.broadcast();
            },

            locked() {
                this.disabled = this.locked;
            }
        },

        methods: {
            onChange() {
                if(this.date)
                    this.broadcast();
            },

            broadcast() {
                this.$emit('changed', {id: this.id, value: this.date});
            }
        }
    }
</script>

<style>
.disabled {
    cursor: default
}
.datepicker > .form-control, .datepicker > .form-control:focus {
    background-color: #0e5381;
    background: #0e5381;
    color: rgba(255, 255, 255, 0.8) !important;
}

.datepicker > .form-control:disabled, .datepicker > .form-control[readonly] {
    background-color: #eeeeee;
    opacity: 1;
    color: #c5cace;
}
.bootstrap-datetimepicker-widget .timepicker-hour, 
.bootstrap-datetimepicker-widget .timepicker-minute,
.bootstrap-datetimepicker-widget .timepicker-second {
    display: contents;
}
span.month, span.year {
    display: inline-block !important;
    width: 54px !important;
    height: 54px !important;
    line-height: 54px !important;
    margin: 2px 1.5px !important;
    cursor: pointer !important;
    border-radius: 4px !important;
}
</style>